module.exports = require("core-js-pure/stable/instance/index-of");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/index-of.js
// module id = 90
// module chunks = 0 1